<template>
    <div>
        <tr>
            <td>
                <div class="font-btn-small">Auszuzahlender Betrag</div>
                <input type="text" class="font-input type-input font-normal" value="CHF 4500.00">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">Kontoinhaber</div>
                <input type="text" class="font-input type-input font-normal" value="Max Mustermann">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">IBAN / Bank Number</div>
                <input type="text" class="font-input type-input font-normal" value="CH90 6810 4036 5094 7">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">BIC / Clearing-Nummer</div>
                <input type="text" class="font-input type-input font-normal" value="BC9435408">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">Straße und Nr.</div>
                <input type="text" class="font-input type-input font-normal" value="Musterstrasse 10">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">PLZ und Ort</div>
                <input type="text" class="font-input type-input font-normal" value="8853 Lachen">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">Land</div>
                <input type="text" class="font-input type-input font-normal" value="Schweiz">
            </td>
        </tr>
    </div>
</template>

<script>
  export default {}
</script>
